import {API} from 'aws-amplify';

export const read = async (limit = 20, startKey = null) =>
  API.get('robinhoodEngUserApi', `/posts`, {
    queryStringParameters: {
      limit,
      startKey,
    },
  });

export const readOne = async (id) => API.get('robinhoodEngUserApi', `/posts/${id}`, {});
